import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 21H4C2.89543 21 2 20.1046 2 19V5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V19C22 20.1046 21.1046 21 20 21ZM4 7V19H20V7H4ZM11 16.121L7.293 12.414L8.707 11L11 13.293L15.293 9L16.707 10.414L11 16.12V16.121Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "WindowCheck"
);
